import { FC } from 'react';

import CircularProgress from '@mui/joy/CircularProgress';
import Stack from '@mui/joy/Stack';
import { alpha } from '@mui/material';

type LoaderProps = {
  sx?: any;
};

const Loader: FC<LoaderProps> = ({ sx }) => (
  <Stack
    sx={{
      position: 'fixed',
      width: '100%',
      minHeight: '100vh',
      justifyContent: 'center',
      alignItems: 'center',
      background: theme => alpha(theme.palette.common.white, 0.5),
      zIndex: 100000,
      ...sx,
    }}
  >
    <CircularProgress />
  </Stack>
);

export default Loader;
